<script>
export default {
  // domain:"http://192.168.10.58:8087"
};
</script>